import { Controller } from '@hotwired/stimulus'

// Polls only the progress panel while an import job is active.
// Avoids full-page reloads so the rest of the page stays stable.
export default class extends Controller {
  static targets = ['panel', 'heading']
  static values = {
    active: Boolean,
    interval: { type: Number, default: 3000 },
    url: String
  }

  connect () {
    if (!this.activeValue || !this.hasUrlValue) return

    this.timer = window.setInterval(() => {
      this.refreshProgress()
    }, this.intervalValue)
  }

  disconnect () {
    this.stop()
  }

  stop () {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }

  async refreshProgress () {
    if (this.fetching || !this.hasPanelTarget) return
    this.fetching = true

    try {
      const response = await window.fetch(this.urlValue, {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) return

      const html = await response.text()
      const doc = new window.DOMParser().parseFromString(html, 'text/html')
      const nextPanel = doc.querySelector('#product-import-progress')
      if (!nextPanel) return

      const stillActive = nextPanel.dataset.importActive === 'true'
      const status = nextPanel.dataset.importStatus || ''

      this.panelTarget.innerHTML = nextPanel.innerHTML
      this.panelTarget.dataset.importActive = nextPanel.dataset.importActive
      this.panelTarget.dataset.importStatus = status

      if (this.hasHeadingTarget && status) {
        this.headingTarget.textContent = this.humanize(status)
      }

      if (!stillActive) {
        this.activeValue = false
        this.stop()
        // One final reload so finished-state copy matches DB (checklist note, etc.).
        window.location.reload()
      }
    } catch (_error) {
      // Keep polling; transient network blips shouldn't kill the job UI.
    } finally {
      this.fetching = false
    }
  }

  humanize (status) {
    return status
      .toString()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }
}
